const appInformation = {
  production: false,
  name: 'demo',
  version: '1.0.0',
  region: 'us-gov-west-1',
  url: 'localhost:4200',
  endpoint: 'https://uam-saf-project-demo.gembotcloud.com',
  sandboxEnabled: false,
};

const redirects = {
  uam: 'http://localhost:4200/auth/login',
  warfigther: 'https://warfighter-demo.gembotcloud.com/',
  safire: 'https://safire-demo.gembotcloud.com'
};



const amplifyInformation = {
  Auth: {
    region: 'us-gov-west-1',
    userPoolId: 'us-gov-west-1_VP8XJy6MV',
    userPoolWebClientId: '42nlatba8r8aemd8btb95leqoj',
    Cognito: {
      userPoolClientId: '42nlatba8r8aemd8btb95leqoj',
      userPoolId: 'us-gov-west-1_VP8XJy6MV',
    },

    cookieStorage: {
      domain: '.gembotcloud.com',
      path: '/',
      expires: 365,
      sameSite: 'strict',
    },
  },
};

const cookieInfo = {
  cookieStorage: {
    domain: '.gembotcloud.com',
    path: '/',
    expires: 365,
    sameSite: 'strict',
  }
};

export const environment = {
  ...appInformation,
  redirects,
  cookieInfo,
  amplify: amplifyInformation,
};
